import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { CalendarEventService } from './calender-event.service';


@Component({
  selector: 'custom-calendar-header',
  standalone: true,
  template: `
    <div class="custom-calendar-header">
      <button mat-icon-button class="nav-button" (click)="previousClicked()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span>{{ getHeaderLabel() }}</span>
      <button mat-icon-button class="nav-button" (click)="nextClicked()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    .custom-calendar-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px;
    }
    .mat-icon {
      color: black;
    }
    .nav-button {
      background-color: transparent;
      color: black;
    }
  `],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class CustomCalendarHeaderComponent<D extends Date> {
  @Output() monthSelected = new EventEmitter<D>();
  @Output() yearSelected = new EventEmitter<D>();

  constructor(
    public calendar: MatCalendar<D>,
    private dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private dateFormats: MatDateFormats,
    private calendarEventService: CalendarEventService // Inject the service
  ) {}

  previousClicked(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1);
    this.calendar.stateChanges.next();
    this.emitMonthYearSelected();
  }

  nextClicked(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1);
    this.calendar.stateChanges.next();
    this.emitMonthYearSelected();
  }

  adjustDateForTimezone(date: Date): Date {
    const adjustedDate = new Date(date);
    adjustedDate.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    return adjustedDate;
  }


  getHeaderLabel(): string {
    const activeDate = this.dateAdapter.toIso8601(this.calendar.activeDate);
    const date = this.adjustDateForTimezone(new Date(activeDate));
    return this.calendar.currentView === 'month' ? date.toLocaleDateString('default', { month: 'long', year: 'numeric' }) : date.getFullYear().toString();
  }

  private emitMonthYearSelected(): void {
    if (this.calendar.currentView === 'month') {
      this.calendarEventService.emitMonthSelected(this.calendar.activeDate);
    } else {
      this.calendarEventService.emitYearSelected(this.calendar.activeDate);
    }
  }
}
